export const memberGoodsRecordTableOption = {
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign: 'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [
  {
    label: '订单号',
    prop: 'id',
    align: 'center',
    width: 80,
  },{
    label: '商品预览',
    width: 260,
    prop: 'goodsInfo',
    overHidden: true,
    solt: true,
    align: 'left'
  },{
    label: '商品分类',
    prop: 'goodsTypes',
    overHidden: true,
    align: 'left',
    width: 120,
  },{
    label: '核销类型',
    prop: 'redeemType',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 120,
  },{
    label: '花费积分',
    prop: 'rewardValue',
    sortable: true,
    align: 'left',
    width: 120,
  }, {
    label: '兑换人昵称',
    prop: 'nickname',
    overHidden: true,
    align: 'left',
    solt: true,
    width: 160
  }, {
    label: '兑换人姓名',
    prop: 'realname',
    overHidden: true,
    align: 'left',
    width: 130
  }, {
    label: '兑换人员工编号',
    prop: 'unionId',
    overHidden: true,
    align: 'left',
    width: 150
  },{
    label: '下单时间',
    prop: 'insertedTime',
    sortable: true,
    align: 'left',
    width: 160,
  },{
    label: '状态',
    prop: 'status',
    overHidden: true,
    solt: true,
    align: 'left',
    width: 120,
  },{
    label: '状态备注',
    prop: 'statusComment',
    overHidden: true,
    align: 'left',
    width: 200,
  }]
}

export const memberGoodsStatusOptions = [
  { label: '已锁定', value: 1 },
  { label: '已兑换', value: 2 },
  { label: '已使用', value: 3 },
  { label: '已过期', value: 4 },
  { label: '兑换失败', value: 5 },
  { label: '待发货', value: 6 },
  { label: '已发货', value: 7 },
  { label: '已确认收货', value: 8 },
]